import { Box, Grid, Button } from "@mui/material";
import SearchBar from "./Searchbar";
import RoleFilter from "./RoleFilter";
import StatusFilter from "./StatusFilter";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";


function Filters({
  role,
  status,
  searchTerm,
  setRole,
  setStatus,
  setSearchTerm,
}) {
  // check if any filter exits
  const isFilter = role || status || searchTerm;
  console.log("isfilter", isFilter);

  const ClearAllFilters = () => {
    setRole("");
    setStatus("");
    setSearchTerm("");
  };


  const primary = colorTheme('palette', 'primary').value;


  return (
    <Grid container spacing={2} alignItems="center" >
      {/* ---------- SearchBar ---------- */}
      <Grid item xs={12} md={12} lg={8}>
        <SearchBar value={searchTerm} onChange={setSearchTerm} />
      </Grid>

      {/* ---------- Filters + Clear ---------- */}
      <Grid
        item
        xs={12}
        md={12}
        lg={4}
        sx={{
          display: "flex",
          justifyContent: { xs: "flex-start", md: "flex-end" },
        }}
      >
        <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
          <RoleFilter value={role} onChange={setRole} />
          <StatusFilter value={status} onChange={setStatus} />
          <Button
            variant="outlined"
            size="small"
            onClick={ClearAllFilters}
            sx={{
              height: 40,
              whiteSpace: "nowrap",
              minWidth: "auto",
              textTransform: "none",
              px: 1.5,
              fontSize: "0.875rem",
              cursor: isFilter ? "pointer" : "default",    
              backgroundColor: isFilter ? primary : "transparent",
              color: isFilter ? "#fff" : "inherit",
              borderColor: isFilter ? primary : "rgba(0,0,0,0.23)",
              "&.Mui-focusVisible": { borderColor:primary },
            }}
          >
            Clear
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Filters;
